import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmationModal } from 'LocalGluons';
import { t } from 'Locale';
import { noop } from 'Utils';

const AppConfirmationModal = ({
    errorMessage: { header = t('COMMON.INFORMATION_MSG'), message = t('COMMON.INFORMATION_MSG') },
    closeCallback,
    mode
}) => (
    <ConfirmationModal
        header={header}
        message={message}
        icon="warning_yellow_black"
        confirmLabel={t('COMMON.OK')}
        onCancel={closeCallback}
        onConfirm={closeCallback}
        mode={mode}
    />
);

AppConfirmationModal.defaultProps = {
    errorMessage: {},
    closeCallback: noop,
    mode: 'portrait'
};

AppConfirmationModal.propTypes = {
    errorMessage: PropTypes.shape({
        header: PropTypes.string,
        message: PropTypes.string
    }),
    closeCallback: PropTypes.func,
    mode: PropTypes.string
};

export { AppConfirmationModal };
